import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './brand/theme.css';
import { applyBrand } from './brand/brand';
import { applyTenant } from './brand/tenant';
import { authBackground } from './brand/assets';
import App from './App';
import { Provider, useSelector } from 'react-redux';
import { createStore } from 'redux';
import auth from './store/user';
import { ErrorProvider } from './helpers/ErrorContext';

export const store = createStore(auth);

// Бренд (DOSCAR / Horizon) выбирается при сборке через REACT_APP_BRAND:
// атрибут для CSS-переменных, заголовок вкладки и фон страницы входа.
applyBrand();
// Брокер поверх бренда (REACT_APP_TENANT): своё название и иконка вкладки.
applyTenant();
document.documentElement.style.setProperty('--brand-auth-bg', `url(${authBackground})`);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <ErrorProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorProvider>
  // </React.StrictMode>
);
